export default __webpack_public_path__ + "static/media/Booking.7ca901f1.svg";